import { Paper } from '@mui/material';
import styled, { css } from 'styled-components';

export const StyledPopperPaper = styled(Paper)`
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  padding: 16px;
  background-color: white;
  min-width: 240px;
  max-width: 320px;
`;

export const ButtonContainer = styled.div`
  width: 36px;
  height: 36px;

  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.colors.greys.darkest};

  background: ${(props) =>
    props.isOpened ? props.theme.colors.greys.darkest : props.theme.colors.greys.lightest};

  &:hover {
    cursor: ${(props) => (props.isDisabled ? 'not-allowed' : 'pointer')};
  }

  ${(props) =>
    props.isDisabled &&
    css`
      border: 1px solid ${props.theme.colors.greys.lighty};
    `}
`;
